import { FormControl } from "./FormControl";

export class FormControls<T>
{
    private m_controls: string[] = [];

    private m_controlsMap: Map<string, FormControl> = new Map<string, FormControl>();
    //    private m_data?: T;
    //    private m_newData?: T;

    constructor(controlFieldMap: string[][])
    {
        for (const mapItem of controlFieldMap)
            this.m_controlsMap.set(mapItem[0], { id: FormControls.idForControlStatic(mapItem[1]), name: FormControls.nameForControlStatic(mapItem[1]) });
    }

    updateForData(data: T)
    {
        // this.m_data = data;
        this.m_controls = Object.getOwnPropertyNames(data);

        // validate that all the forms on this page have a matching field name
        let notFound = 0;

        for (const fieldName of this.m_controls)
        {
            if (!this.m_controlsMap.has(fieldName))
                notFound++;
        }

        // at this point we know how many controls we have, and how many weren't found
        if (this.m_controls.length - notFound != this.m_controlsMap.size)
            throw new Error(`control mismatch: expected ${this.m_controls.length - notFound}, but found ${this.m_controlsMap.size}`);
    }

    static nameForControlStatic(control: string): string
    {
        return `${control}_input`;
    }

    //    valueForControl(control: string): string
    //    {
    //        if (this.m_data)
    //        {
    //            return (this.m_data as any)[control];
    //        }
    //        return "";
    //    }

    nameForControl(control: string): string
    {
        if (!this.m_controlsMap.has(control))
            throw new Error(`${control} not found`);

        return this.m_controlsMap.get(control)!.id;
    }

    static idForControlStatic(control: string): string
    {
        // make sure this control exists in our set of controls
        return `${control}-input`;
    }


    idForControl(control: string): string
    {
        if (!this.m_controlsMap.has(control))
            throw new Error(`${control} not found`);

        return this.m_controlsMap.get(control)!.name;
    }

    getDataFromFormForEvent(formEvent: React.FormEvent): T
    {
        const newData: any = {};
        const target = formEvent.target as any;

        for (const control of this.m_controls)
        {
            const controlName: string = this.nameForControl(control);

            if (target[controlName])
                newData[control] = target[controlName].value;
        }

        return newData as T;
    }


    //    setNewDataFromForm(formEvent: React.FormEvent)
    //    {
    //        const newData: any = {};
    //        const target = formEvent.target as any;
    //
    //        for (const control of this.m_controls)
    //        {
    //            const controlName: string = this.nameForControl(control);
    //
    //            if (target[controlName])
    //                newData[control] = target[controlName].value;
    //        }
    //
    //        this.m_newData = newData as T;
    //    }
}